import EventSystem from './utils/EventSystem';

class Circles {
  // Initialization
  constructor(args) {
    // Get dimensions
    this.width = document.body.clientWidth;
    this.height = document.body.clientHeight;

    // Define colors
    this.colors = ['#1f6ada', '#ff3900', '#00cc99'];

    // Define drawing vars
    this.treeBackgroundPadding = 50;

    // Get Canvas container
    this.canvas = d3.select('.circles').append('canvas');

    // Set sizes
    this.canvas.property('width', this.width);
    this.canvas.property('height', this.height);

    // Get Labels container
    this.labelContainer = d3.select('.labels');

    // Get canvas element
    this.ctx = this.canvas.node().getContext('2d');

    // Get current d3 transform
    this.transform = d3.zoomIdentity;

    // Register drag, zoom and other events for canvas
    this.bindBasicEvents();
    this.enableZoom();
    this.enableDrag();

    // Call to draw first canvas frame
    this.drawCanvas();

    // Events

    // Resize Event
    window.addEventListener('resize', evt => this.resized(evt));

    EventSystem.$on('area-changed', area => {
      this.hide(() => {
        this.nodes.sort((a, b) => (a.direction === area ? -1 : (b.direction === area ? 1 : -1)));
        this.createMap(this.nodes);
        this.filterNodes({ area });

        const valueMax = Math.max.apply(Math, (this.filteredNodes || this.nodes).map((o) => (o.y * o.x) / 700 ));

        this.transform.k = Math.min(1, this.height / valueMax);
        this.transform.x = (this.width / 2) - ((this.width / 2) * this.transform.k);
        this.transform.y = (this.height / 2) - ((this.height / 2) * this.transform.k);

        this.show();
      });
    });
    EventSystem.$on('front-changed', front => {
      this.hide(() => {
        this.filteredNodes = undefined;
        this.loadFront(front.file);
      });
    });
    EventSystem.$on('areas-loaded', front => {
      this.show();
    });
    EventSystem.$on('tree-view-close', () => {
      this.undoAnimation();
      this.animationStruct.nodes.forEach((k) => {
        for (var m in this.oldRNodes) {
          if (k.id == m) {
            k.r = this.oldRNodes[m];
          }
        }
      });
      this.oldRNodes = [];
    });
    EventSystem.$on('selected-node', node => {
      if (this.hidden) return;
      this.collidingNode = this.nodes.find(n => n.id === node.id);
      this.canvasClick();
    });
  }

  // Draw Functions
  drawCanvas() {
    // Call to draw canvas
    requestAnimFrame(() => { this.drawCanvas() });

    var startTime = performance.now();

    if (this.animatingNodes) {
      this.drawAnimation();
    } else {
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.drawSimulation();
    }

    window.drawDelta = performance.now() - startTime;
    // this.drawDebug();
  }
  drawSimulation() {
    // Draw canvas nodes using D3 force layout
    // Update labels position
    if (this.collidingNode) {
      var el = document.querySelector(`#label-${this.collidingNode.id}`);
      if (el) {
        var x = this.nodeX - Math.round(el.offsetWidth / 2);
        var y = this.nodeY - (30 * d3.easeCubicOut(1 - (this.transform.k / 8))) - Math.round(el.offsetHeight / 2);
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
      }
    }

    if (!this.links || !this.nodes) return;

    var nodes = this.filteredNodes || this.nodes;
    var links = this.links;
    var ctx = this.ctx;

    ctx.save();
    ctx.translate(this.transform.x, this.transform.y);
    ctx.scale(this.transform.k, this.transform.k);
    ctx.fillStyle = '#333';
    ctx.lineWidth = 3;

    // links.forEach(l => {
    //   ctx.beginPath();
    //   ctx.setLineDash(l.value === 0 ? [] : [3, 3]);
    //   ctx.moveTo(l.source.x, l.source.y);
    //   ctx.lineTo(l.target.x, l.target.y);
    //   ctx.stroke();
    // });

    nodes.forEach(n => this.drawNode(n));

    var closest = this.getClosestNode(nodes);

    ctx.fillStyle = '#333';
    if (closest) {
      if (this.collidingNode) {
        this.labelHover(this.collidingNode, 0);
      }
      this.labelHover(closest.node, 1);

      this.collidingNode = closest.node;

      // this.drawNode({ ...closest.node, radius: 26 });
      closest.node.ir = Math.min(1.2, closest.node.ir ? closest.node.ir * 1.02 : 0.9);
      this.drawNode({ ...closest.node, r: closest.node.r * closest.node.ir }, true);
    } else {
      if (this.collidingNode) {
        this.labelHover(this.collidingNode, 0);
      }
      this.collidingNode = undefined;
    }

    ctx.restore();
  }
  drawAnimation() {
    // Draw Tree view (mainly for animation coordination)
    var ctx = this.ctx;
    var ac = this.animationCoordinator;
    var ans = this.animationStruct;

    var delta = new Date().getTime() - ac.started;
    var percent = ac.durations[0] ? delta / ac.durations[0] : Infinity;

    if ((ac.phases[0] === 'zoomout' || ac.phases[0] === 'zoomfadeout') && percent <= 1) {
      this.transform.k = ((ac.animation.zoomout.fromK - 1) * (1 - d3.easePolyInOut(percent, 4.0))) + 1;
      this.transform.x = ac.animation.zoomout.fromX * (1 - d3.easePolyInOut(percent, 4.0)) + (180 * d3.easePolyInOut(percent, 4.0));
      this.transform.y = ac.animation.zoomout.fromY * (1 - d3.easePolyInOut(percent, 4.0)) + (31 * d3.easePolyInOut(percent, 4.0));
      this.drawSimulation();
    }

    if ((ac.phases[0] === 'fadeout' || ac.phases[0] === 'zoomfadeout') && percent <= 1) {
      this.ctx.clearRect(0, 0, this.width, this.height);
      ctx.globalAlpha = 1 - d3.easePolyInOut(percent, 2);
      this.drawSimulation();
      ctx.globalAlpha = 1;
      this.drawAnimationSub(true);
    }

    if (ac.phases[0] === 'position' && percent <= 1) {
      var animationAlpha = d3.easePolyInOut(percent, 4.0);
      ans.nodes.forEach(n => {
        n.x = n.originX + ((n.targetX - n.originX) * animationAlpha);
        n.y = n.originY + ((n.targetY - n.originY) * animationAlpha);
      });
      this.drawAnimationSub();
    }

    if (ac.phases[0] === 'labelsfadein' && percent <= 1) {
      ac.animation.labelsfadein.forEach(st => {
        if (!st.positioned) {
          st.positioned = true;
          st.label.style.left = `${Math.round(st.node.x - (st.label.offsetWidth / 2))}px`;
          st.label.style.top = `${Math.round(st.node.y - (st.label.offsetHeight / 2))}px`;
        }
        st.label.style.opacity = d3.easePolyInOut(percent, 4.0);
      });
    }

    if (ac.phases[0] === 'labelsfadeout' && percent <= 1) {
      ac.animation.labelsfadein.forEach(st => {
        st.label.style.opacity = 1 - d3.easePolyInOut(percent, 4.0);
      });
    }

    if (ac.phases[0] === 'unposition' && percent <= 1) {
      var animationAlpha = d3.easePolyInOut(percent, 4.0);
      ans.nodes.forEach(n => {
        n.x = n.targetX + ((n.originX - n.targetX) * animationAlpha);
        n.y = n.targetY + ((n.originY - n.targetY) * animationAlpha);
      });
      this.drawAnimationSub();
    }

    if ((ac.phases[0] === 'zoomin' || ac.phases[0] === 'zoomfadein') && percent <= 1) {
      var z = ac.animation.zoomin;

      this.transform.k = z.fromK + ((z.toK - z.fromK) * d3.easePolyInOut(percent, 4.0));
      this.transform.x = z.fromX + ((z.toX - z.fromX) * d3.easePolyInOut(percent, 4.0));
      this.transform.y = z.fromY + ((z.toY - z.fromY) * d3.easePolyInOut(percent, 4.0));
      this.drawSimulation();
    }

    if ((ac.phases[0] === 'fadein' || ac.phases[0] === 'zoomfadein') && percent <= 1) {
      this.ctx.clearRect(0, 0, this.width, this.height);
      ctx.globalAlpha = d3.easePolyInOut(percent, 2);
      this.drawSimulation();
      ctx.globalAlpha = 1;
      this.drawAnimationSub(true);
    }

    if (percent > 1) {
      ac.durations = ac.durations.slice(1);
      ac.phases = ac.phases.slice(1);
      ac.started = new Date().getTime();

      if (ac.phases[0] === 'end') {
        this.animatingNodes = false;
        this.nodeClickDisabled = false;
      } else if (ac.phases.length === 0) {
        this.labelhoverDisabled = false;
        this.recalcLabelPositions();
        // this.drawTreeBack();
        this.drawAnimationSub();
      }
    }
  }
  drawAnimationSub(ignoreClear) {
    // Draw subroutine for tree view

    var ctx = this.ctx;
    // Get a link to find out current alpha
    // var refLink = this.animationStruct.links[0];
    // Get animation alpha
    // var positionAlpha;
    // if (refLink) {
    //   positionAlpha = Math.abs(
    //     (refLink.target.x - refLink.target.originX)
    //     /
    //     (refLink.target.originX - refLink.target.targetX)
    //   );
    // }
    // Wheter the animation ended or not
    var animationEnded = this.animationCoordinator.durations.length === 0;

    // Save context for restoration later
    ctx.save();

    // If clear was not ignored
    if (!ignoreClear) {
      // Fill canvas with white background (more efficient than clearRect)
      // ctx.fillStyle = '#DFEFF6';
      // ctx.fillRect(0, 0, this.width, this.height);
      ctx.clearRect(0, 0, this.width, this.height);
    }
    // Translates canvas as of transform value
    ctx.translate(this.transform.x, this.transform.y);
    // Scales canvas as of transform value
    ctx.scale(this.transform.k, this.transform.k);
    // Set new fill style and line width
    ctx.fillStyle = '#333';
    ctx.lineWidth = 3;

    // Get closest node to mouse
    var closest;
    if (animationEnded) {
      closest = this.getClosestNode(this.animationStruct.nodes);
    }
    var activeNodesList;
    var struct;
    if (closest) {
      struct = {
        lastNode: null,
        currentNode: closest.node,
        lastLevel: 0,
        lastSubLevel: 0,
        treeViewLayers: [],
        targetNodesIds: new Set(),
        linksList: new Set(),
      };
      this.depthSearch(struct);
      activeNodesList = struct.targetNodesIds;
      this.collidingNode = closest.node;
    } else {
      activeNodesList = this.animationStruct.targetNodesIds;
      this.collidingNode = null;
    }

    // For each link
    this.animationStruct.links.forEach(link => {
      var source = link.source;
      var target = link.target;

      if (activeNodesList.has(target.id) && activeNodesList.has(source.id)) {
        ctx.globalAlpha = 1;
      } else {
        ctx.globalAlpha = 0.1;
      }

      // var txoff = 0;
      // var sxoff = 0;
      var bendSideways;
      // If can bend
      if (target.underLayer) {
        // If difference is bigger than one
        if (Math.abs(source.x - target.x) > 1) {
          // If is from two different layers
          if (target.nivel !== source.nivel) {
            // If lower node is to the left
            if (source.x > target.x) {
              bendSideways = [1, 0, -1, 0];
            // If lower node is to the right
            } else {
              bendSideways = [-1, 0, 1, 0];
            }
          // From same layer
          } else {
            // If lower node is to the left
            if (source.x > target.x) {
              bendSideways = [1, 0, 0, 0.5];
            // If lower node is to the right
            } else {
              bendSideways = [-1, 0, 0, 0.5];
            }
          }
        // Difference is not bigger than 1
        } else {
          if (target.nivel !== source.nivel) {
            bendSideways = [1, 0, 1, 0];
          } else {
            bendSideways = [0, 0, 0, 0];
          }
        }
      }

      // Begin a new path
      ctx.beginPath();
      // Move path to the link starting point
      ctx.moveTo(target.x, target.y);
      // Set line dashed or solid
      ctx.setLineDash(link.value === 0 ? [] : [3, 3]);
      // Draw line
      ctx.lineTo(source.x, source.y);
      // Draw the link with the current path
      ctx.stroke();
    });

    // For each node in the struct
    this.animationStruct.nodes.forEach(node => {
      if (activeNodesList.has(node.id)) {
        ctx.globalAlpha = 1;
        // if (closest && animationEnded) {
        //   // this.labelHover(node, 1);
        // } else {
        //   this.labelHover(node, 0);
        // }
      } else {
        ctx.globalAlpha = 0.1;
      }

      if (closest && node.id === closest.node.id) {
        this.drawNode(node, true);
        this.labelHover(node, 1);
      } else {
        this.labelHover(node, 0);
      }

      // Draw the node with the given radius
      this.drawNode(node, this.preSelectedNode  && node.id === this.preSelectedNode.id);
    });

    ctx.restore();
  }
  drawTreeBack() {
    // Draws tree view background info
    var ctx = this.ctx;

    ctx.save();
    // ctx.fillStyle = '#DFEFF6';
    // ctx.fillRect(0, 0, this.width, this.height);
    ctx.clearRect(0, 0, this.width, this.height);
    ctx.translate(this.transform.x, this.transform.y);
    ctx.scale(this.transform.k, this.transform.k);

    var asn = this.animationStruct;
    var layerHeight = this.height / (asn.treeViewLayers.length + 1);

    asn.treeViewLayers.forEach((layer, index) => {
      var ii = (asn.treeViewLayers.length + 1) - index;
      var sampleNode = layer[0][0];
      var y = (ii - 1) * layerHeight;

      var grd = ctx.createLinearGradient(0, 0, this.width, 0);
      grd.addColorStop(0, this.colors[sampleNode.group]);
      grd.addColorStop(0.5, this.colors[sampleNode.group]);
      grd.addColorStop(1, 'white');
      ctx.fillStyle = grd;
      ctx.globalAlpha = 0.1;
      ctx.fillRect(0, (y - (layerHeight / 2)) + this.treeBackgroundPadding / 2, this.width, layerHeight - this.treeBackgroundPadding);
      ctx.fillStyle = this.colors[sampleNode.group]
      ctx.globalAlpha = 1;
      ctx.fillRect(0, (y - (layerHeight / 2)) + this.treeBackgroundPadding / 2, 4, layerHeight - this.treeBackgroundPadding);
      ctx.font = '48px Tahoma';
      ctx.fillText(sampleNode.nivel, 25, y + 20);
      // ctx.font = '400 12px Tahoma';
      // ctx.fillText(this.levelNames[sampleNode.nivel], 25, y + 44);
    });

    ctx.restore();
  }
  drawNode(node, selected) {
    // Draws single node
    var ctx = this.ctx;

    ctx.beginPath();
    ctx.fillStyle = ctx.strokeStyle = node.color || this.colors[node.group];
    if (selected) {
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      ctx.arc(node.x, node.y, node.r ? node.r + 5 : 24, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
    }
    ctx.arc(node.x, node.y, node.r || 22, 0, Math.PI * 2);
    ctx.fill();
  }
  drawDebug() {
    if (window.meanTime75) {
      window.meanTime75 = (window.meanTime75 * 0.75) + (window.drawDelta * 0.25);
      window.meanTime99 = (window.meanTime99 * 0.99) + (window.drawDelta * 0.01);
      window.meanTime995 = (window.meanTime995 * 0.995) + (window.drawDelta * 0.005);
    } else {
      window.meanTime75 = window.drawDelta;
      window.meanTime99 = window.drawDelta;
      window.meanTime995 = window.drawDelta;
    }

    if (window.meanTimeSimul75) {
      window.meanTimeSimul75 = (window.meanTimeSimul75 * 0.75) + (window.simulationDelta * 0.25);
      window.meanTimeSimul99 = (window.meanTimeSimul99 * 0.99) + (window.simulationDelta * 0.01);
      window.meanTimeSimul995 = (window.meanTimeSimul995 * 0.995) + (window.simulationDelta * 0.005);
    } else {
      window.meanTimeSimul75 = window.simulationDelta;
      window.meanTimeSimul99 = window.simulationDelta;
      window.meanTimeSimul995 = window.simulationDelta;
    }

    var ctx = this.ctx;
    var messages = [
      `[ DRAW TIME ]`,
      `|  [Instant]   ${Math.round(window.drawDelta * 10) / 10} ms`,
      `|  [75%]       ${Math.round(window.meanTime75 * 10) / 10} ms`,
      `|  [99%]       ${Math.round(window.meanTime99 * 10) / 10} ms`,
      `|  [99.5%]     ${Math.round(window.meanTime995 * 10) / 10} ms`,
      '',
      '',
      `[ SIMULATION TIME ]`,
      `|  [Instant]   ${Math.round(window.simulationDelta * 10) / 10} ms`,
      `|  [75%]       ${Math.round(window.meanTimeSimul75 * 10) / 10} ms`,
      `|  [99%]       ${Math.round(window.meanTimeSimul99 * 10) / 10} ms`,
      `|  [99.5%]     ${Math.round(window.meanTimeSimul995 * 10) / 10} ms`];
    var offset = this.height - (messages.length * 15);

    ctx.font = '600 10px Courier, arial';
    ctx.fillStyle = '#FFF';
    ctx.globalAlpha = 0.8;
    ctx.fillRect(0, offset - 15, 150, this.height);
    ctx.fillStyle = '#333';
    ctx.globalAlpha = 1;
    messages.forEach((m, i) => {
      ctx.fillText(m, 10, offset + (i * 15));
    });
  }

  // General Utils
  loadFront(front) {
    d3.json(front, (error, data) => {
      if (error) throw new Error('Erro ao carregar dados (JSON)')

      // Prevent data mutation
      var graph = data[Object.keys(data)[0]];
      var graphNodeIds = [...new Set(graph.nodes.map(n => n.id))];
      // Save a copy of data to window object
      window.$areas = Array.from(new Set(graph.nodes.map(e => e.direction)));
      window.$nodes = graph.nodes.map(n => Object.freeze({ ...n }));
      if (graph.links) {
        window.$links = graph.links.map(l => Object.freeze({ ...l }));
      } else {
        graph.links = [];
        window.$links = [];
      }

      // Nodes
      this.nodes = graph.nodes.sort((a, b) => Math.random() > 0.5);

      // Links
      this.links = graph.links.filter(l =>
        ~graphNodeIds.indexOf(l.source)
        &&
        ~graphNodeIds.indexOf(l.target)
      ).sort((b, a) => a.source === b.source ? a.target - b.target : a.source - b.source);

      this.links.forEach(l => {
        l.source = this.nodes.find(n => n.id === l.source);
        l.target = this.nodes.find(n => n.id === l.target);
      });

      // Generate circle map
      this.createMap(this.nodes);

      const valueMax = Math.max.apply(Math, this.nodes.map((o) => (o.y * o.x) / 700 ));

      this.transform.k = Math.min(1, this.height / valueMax);
      this.transform.x = (this.width / 2) - ((this.width / 2) * this.transform.k);
      this.transform.y = (this.height / 2) - ((this.height / 2) * this.transform.k);

      // Create Labels
      this.labels = this.labelContainer
        .selectAll('div')
        .data(graph.nodes)
        .attr('class', 'labels-in')
        .attr('id', d => `label-${d.id}`)
        .text(d => `${d.cargo}`);

      // Enter nodes update
      this.labels
        .enter()
        .append('div')
        .attr('class', 'labels-in')
        .attr('id', d => `label-${d.id}`)
        .text(d => `${d.cargo}`);

      this.labels
        .exit().remove();

      EventSystem.$emit('areas-loaded');
    });
  }
  recalcLabelPositions() {
    // Recalculates all label positions given node new position
    this.animationCoordinator.animation.labelsfadein.forEach(al => {
      var el = al.label;
      var x, y;
      if (el) {
        if (!el.hasOwnProperty("offsetWidth")) {
          x = al.node.x;
        } else {
          x = al.node.x - Math.round((el.offsetWidth / this.transform.k) / 2);
        }

        el.style.left = `${(x * this.transform.k) + this.transform.x}px`;

        if (!el.hasOwnProperty("offsetHeight")) {
          y = al.node.y;
        } else {
          y = al.node.y - Math.round((el.offsetHeight / this.transform.k) / 2);
        }

        el.style.top = `${(y * this.transform.k) + this.transform.y}px`;
      }

    });
  }
  undoAnimation() {
    if (this.hidden) return;
    this.enableDrag();
    this.enableZoom();

    // Undoes Tree Animation
    this.animationCoordinator.durations = [200, 450, 450];
    this.animationCoordinator.animation.zoomin.fromK = this.transform.k;
    this.animationCoordinator.animation.zoomin.fromX = this.transform.x;
    this.animationCoordinator.animation.zoomin.fromY = this.transform.y;
    this.animationCoordinator.phases = [/*'labelsfadeout' ,*/'unposition', 'zoomfadein', 'end'];
  }
  collidePrecise(n1, n2) {
    return (
      ((n2.x - n1.x) ** 2) +
      ((n2.y - n1.y) ** 2) <
      ((n1.r + n2.r) ** 2)
    )
  }
  hide(cb) {
    d3.selectAll('.labels-in').style('opacity', 0);
    this.canvas
      .transition()
      .duration(200)
      .style('opacity', 0)
      .on('end', () => {
        this.hidden = true;
        if (typeof cb === 'function') cb();
      });
  }
  show(cb) {
    this.bindBasicEvents();
    this.canvas
      .transition()
      .duration(200)
      .style('opacity', 1)
      .on('end', () => {
        this.hidden = false;
        if (typeof cb === 'function') cb();
        EventSystem.$emit('nodes-shown');
      });
  }
  enableDrag() {
    this.labelContainer.call(d3
      .drag()
      .subject(() => this.canvasDragSubject())
      .on('start', () => this.canvasDragStart())
      .on('end', () => this.canvasDragEnded())
    );
  }
  enableZoom() {
    this.labelContainer.call(d3
      .zoom()
      .scaleExtent([0.125, 2])
      .on('zoom', () => this.canvasZoomed())
    )
    .on('dblclick.zoom', null);
  }
  bindBasicEvents() {
    this.labelContainer
      .on('click', () => this.canvasClick())
      .on('mousemove', () => this.canvasMouseMove())
    ;
  }
  disableDrag() {
    this.labelContainer.on('.drag', null);
  }
  disableZoom() {
    this.labelContainer.on('.zoom', null);
  }

  // Node Utils
  depthSearch(ns) {
    // Depth-first search for all child nodes using the links
    var cnode = ns.currentNode;
    var currentSubLevel = ns.lastLevel === cnode.nivel ? ns.lastSubLevel + 1 : 0

    if (currentSubLevel > 0) {
      ns.currentNode.referenceNode = ns.lastNode;
    }

    if (ns.treeViewLayers[cnode.nivel]) {
      if (ns.treeViewLayers[cnode.nivel][currentSubLevel]) {
        ns.treeViewLayers[cnode.nivel][currentSubLevel].push(cnode);
      } else {
        ns.treeViewLayers[cnode.nivel][currentSubLevel] = [cnode];
      }
    } else {
      ns.treeViewLayers[cnode.nivel] = [[cnode]];
    }

    var children = this.links.filter(l => (
      l.target.id === cnode.id &&
      !ns.targetNodesIds.has(l.source.id)
    ));
    ns.targetNodesIds.add(cnode.id);

    children.forEach(c => {
      this.depthSearch({
        ...ns,
        lastNode: cnode,
        currentNode: this.nodes.find(n => n.id === c.source.id),
        lastLevel: cnode.nivel,
        lastSubLevel: currentSubLevel,
      });
    });
  }
  distance(n) {
    // Measure colliding distance for nodes
    if (Math.abs(this.mouseX - n.x) < 22 &&
        Math.abs(this.mouseY - n.y) < 22) {
      return ((this.mouseX - n.x) ** 2) + ((this.mouseY - n.y) ** 2);
    }
    return null
  }
  getClosestNode(nodes) {
    var closest = { dist: Infinity, node: null };
    nodes.forEach(n => {
      var dist = this.distance(n);
      if (dist && dist < closest.dist) {
        closest = { dist: dist, node: n };
      }
    });

    return closest.node ? closest : null;
  }
  studyNodes() {
    // Gather nodes and links information based on the current colliding node
    var layers = [];
    this.nodes.forEach(n => {
      layers[n.nivel] = layers[n.nivel] ? [...layers[n.nivel], n] : [n];
    });

    var struct = {
      lastNode: null,
      currentNode: this.collidingNode,
      lastLevel: 0,
      lastSubLevel: 0,
      treeViewLayers: [],
      targetNodesIds: new Set(),
      linksList: new Set(),
    };
    this.depthSearch(struct);

    return { layers, dsearch: struct };
  }
  createMap(nodes) {
    this.balls = [];
    var angle = 0;
    var radius = 0;
    var maxIterations = 100000;
    var iterations = 0;
    return nodes.forEach(n => {
      if (++iterations > maxIterations) {
        return;
      }
      var collided;
      var r = ((+n.nivel / 13) * 20) + 15;
      do {
        var x = Math.cos(angle) * radius * Math.max(0.85, Math.random());
        var y = Math.sin(angle) * radius * Math.max(0.85, Math.random()) * 0.85;

        collided = false;

        this.balls.forEach(b => {
          // if (this.collideBroad(b, { x, y, r })) {
            if (this.collidePrecise(b, { x, y, r })) {
              collided = true;
            }
          // }
        });
        if (angle <= 350) {
          // angle += Math.max(1, 30 * (radius / this.width)) * Math.random();
          angle += Math.random()
        } else {
          angle = (360 + Math.max(1, 10 * (radius / this.width))) - angle;
          radius += 10;
        }
      } while (collided);
      this.balls.push({ x, y, r });
      // return { ...n, x: x + (this.width / 2), y: y + (this.height / 2), r: r * 0.8 };

      n.x = x + (this.width / 2);
      n.y = y + (this.height / 2);
      n.r = r * 0.8;
    });
  }
  filterNodes(args) {
    if (args.area) {
      if (args.area === 'Todas') {
        this.filteredNodes = undefined;
      } else {
        var filteredNodes = this.nodes.filter(n => n.direction === args.area);
        this.filteredNodes = filteredNodes;
      }
    }
  }

  // Events
  canvasZoomed() {
    if (this.nodeClickDisabled) return;
    // Callback on canvas zoom event
    this.transform = d3.event.transform;
  }
  canvasDragStart() {
    // Callback on canvas start drag element
    this.isDragging = true;
    this.nodeDragged = d3.event.subject;
    this.lastMousePosX = d3.event.subject.x = this.transform.invertX(d3.event.x);
    this.lastMousePosY = d3.event.subject.y = this.transform.invertY(d3.event.y);
  }
  canvasDragSubject() {
    return null;
    // Ignore drag event
    if (this.animatingNodes) return null;

    // Callback on canvas drag element
    var i;
    var x = this.transform.invertX(d3.event.x);
    var y = this.transform.invertY(d3.event.y);
    var dx;
    var dy;

    for (i = this.nodes.length - 1; i >= 0; --i) {
      var node = this.nodes[i];
      dx = x - node.x;
      dy = y - node.y;
      if (dx * dx + dy * dy < 25 * 25) {
        node.x = this.transform.applyX(node.x);
        node.y = this.transform.applyY(node.y);
        this.isDragging = true;
        this.nodeDragged = node;
        return node;
      }
    }
  }
  canvasDragEnded() {
    // Callback on canvas end drag element
    this.isDragging = false;
    this.nodeDragged = undefined;
  }
  canvasClick() {
    // Callback for node clicked
    // If no node was clicked
    if (!this.collidingNode) return;
    if (this.nodeClickDisabled) {
      this.preSelectedNode = this.collidingNode;
      EventSystem.$emit('tree-view-node-click', this.collidingNode);
      return;
    }

    // Hide current label
    EventSystem.$emit('tree-view-open', this.collidingNode);
    this.labelHover(this.collidingNode, 0);
    this.labelhoverDisabled = true;
    this.nodeClickDisabled = true;
    this.preSelectedNode = this.collidingNode;
    this.disableDrag();
    this.disableZoom();

    var study = this.studyNodes();
    var struct = study.dsearch;
    struct.treeViewLayers = struct.treeViewLayers.filter(l => l);
    struct.nodes = [];
    struct.links = this.links.filter(l => (
      struct.targetNodesIds.has(l.source.id)
      &&
      struct.targetNodesIds.has(l.target.id)
    ));

    // var heightSteps = Math.max(200, this.height / (struct.treeViewLayers.length + 1));
    var heightSteps = (this.height - 200) / (struct.treeViewLayers.length);
    var offsetBase = 0;

    if (heightSteps >= 200) {
      offsetBase = ((heightSteps - 200) * (struct.treeViewLayers.length)) / 2;
      heightSteps = 200;
    }

    struct.treeViewLayers.forEach((layer, y) => {
      var iy = (struct.treeViewLayers.length - 1) - y;
      var ySubStep;
      if (layer.length > 1) {
        ySubStep = heightSteps / (layer.length + 1);
      } else {
        ySubStep = heightSteps / 2;
      }
      var yBase = (iy * heightSteps) + ySubStep + offsetBase;

      layer.forEach((subLayer, yoff) => {
        var iyoff = (layer.length - 1) - yoff;
        subLayer.forEach((node, x) => {
          if (yoff > 0 && subLayer.length === 1) {
            node.originX = node.x;
            node.originY = node.y;
            node.targetX = node.referenceNode.targetX;
            node.targetY = yBase + (iyoff * ySubStep) + 90;
          } else {
            node.originX = node.x;
            node.originY = node.y;
          node.targetX = (((x + 1) * (this.width - 800)) / (subLayer.length + 1)) + 600;
            node.targetY = yBase + (iyoff * ySubStep) + 90;
          }
          node.underLayer = yoff !== layer.length - 1;
          struct.nodes.push(node);
        });
      });
    });

    this.oldRNodes = [];
    struct.nodes.forEach((k) => {
      if (!this.oldRNodes[k.id]) {
        this.oldRNodes[k.id] = k.r;
        k.r = 10;
      }
    });

    EventSystem.$emit('tree-view-data', {
      hSteps: heightSteps,
      height: this.height - 200,
      width: this.width - 361,
      layers: JSON.parse(stringify(struct.treeViewLayers, null, 2)),
    });

    function stringify(obj, replacer, spaces, cycleReplacer) {
      return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
    }
    
    function serializer(replacer, cycleReplacer) {
      var stack = [], keys = []
    
      if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]"
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
      }
    
      return function(key, value) {
        if (stack.length > 0) {
          var thisPos = stack.indexOf(this)
          ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
          ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
          if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
        }
        else stack.push(value)
    
        return replacer == null ? value : replacer.call(this, key, value)
      }
    }

    // Set variables for canvas animation
    this.animationStruct = struct;
    this.animationCoordinator = {
      durations: [450, 450/*, 200*/],
      phases: ['zoomfadeout', 'position'/*, 'labelsfadein'*/],
      selectedNodeId: this.collidingNode.id,
      started: new Date().getTime(),
      verticalPad: heightSteps,
      animation: {
        zoomout: {
          fromK: this.transform.k, fromX: this.transform.x, fromY: this.transform.y,
        },
        zoomin: {
          toK: this.transform.k, toX: this.transform.x, toY: this.transform.y,
        },
        labelsfadein: Array.from(struct.targetNodesIds).map(id => ({
          label: document.querySelector(`#label-${id}`),
          node: struct.nodes.find(n => n.id === id),
          positioned: false,
        })),
      },
    };
    this.animatingNodes = true;
  }
  canvasMouseMove() {
    // Callback on canvas mouse move
    this.mouseX = (d3.event.pageX - this.transform.x) / this.transform.k;
    this.mouseY = (d3.event.pageY - this.transform.y) / this.transform.k;
    if (this.collidingNode) {
      this.nodeX = (this.collidingNode.x * this.transform.k) + this.transform.x;
      this.nodeY = (this.collidingNode.y * this.transform.k) + this.transform.y;
    } else {
      this.nodeX = 0;
      this.nodeY = 0;
    }
  }
  labelHover(d, state) {
    // Shows label on hover
    if (this.labelhoverDisabled) return;
    var el = document.querySelector(`#label-${d.id}`);
    if (el) {
      el.style.opacity = state;
    }
  }

  // @todo: resize event
  resized(evt) {
    if (!this.nodes) return;
    const diffW = document.body.clientWidth - this.width;
    const diffH = document.body.clientHeight - this.height;

    // // Get dimensions
    this.width = document.body.clientWidth;
    this.height = document.body.clientHeight;

    // // Set sizes
    this.canvas.property('width', this.width);
    this.canvas.property('height', this.height);

    this.nodes.forEach(n => {
      n.x += diffW / 2;
      n.y += diffH / 2;
    });

  }
};

export default Circles;



// WEBPACK FOOTER //
// ./assets/js/source/circles.js